import { RouteRecordRaw } from 'vue-router';
import { AppRoutes } from './app';

export const Routes: RouteRecordRaw[] = [
  // Application Routes
  // DB Routes
  ...AppRoutes,
];
